<template>
  <div class="practice">
    <!-- title -->
    <h6 class="p-2 pt-md-0 font-weight-bold text-left text-xl">
      {{ [geptLabel(level), geptDisplayText(unitTitle), geptExamTypeLabel($route.params.practice_type)]
          .filter(Boolean)
          .join(' - ')
      }}
    </h6>
    <!-- type tabs -->
    <ul class="d-flex w-100 text-center font-weight-bold pl-0 mb-0" v-if="$route.params.practice_type">
      <li v-for="(item, index) in typeArr"
        :key="index"
        class="flex-1 px-1 px-md-2 mb-0"
        @click="selectQuestion(index)">
        <a
          class="d-inline-block gept_main_color border-1 border-bottom-0 border_main5 p-1 p-md-3 w-100 rounded-top h-100 font-weight-bold"
          :class="{
            active: selectedTypeIdx === index
          }"
        >
          {{ geptLabel(item) }}
        </a>
      </li>
    </ul>
    <!-- content -->
    <div class="content w-100 px-md-2">
      <div class="content_inner">
        <SelectType
          v-if="!$route.params.practice_type"
          :speakingArr="speakingArr"
          :writingArr="writingArr" />

        <div v-if="$route.params.practice_type && typeArr.length > 0 && examData">
          <!-- speaking -->
          <Repeat
            v-if="typeArr[selectedTypeIdx] === '複誦'"
            :level="level"
            :questionData="examData"
            :unitTitle="unitTitle"
            :unit="typeArr[selectedTypeIdx]"
            @setIsStart="setIsStart"
            :isFirstGroup="calculateIsFirst(typeArr[selectedTypeIdx])"
            :isLastGroup="calculateIsLast(typeArr[selectedTypeIdx])"
            @guideNextType="guideNextType"
          />

          <Read_sentences
            v-if="
              typeArr[selectedTypeIdx] === '朗讀句子與短文' ||
              typeArr[selectedTypeIdx] === '朗讀短文'
            "
            :level="level"
            :questionData="examData"
            :unitTitle="unitTitle"
            :unit="typeArr[selectedTypeIdx]"
            @setIsStart="setIsStart"
            :isFirstGroup="calculateIsFirst(typeArr[selectedTypeIdx])"
            :isLastGroup="calculateIsLast(typeArr[selectedTypeIdx])"
            @guideNextType="guideNextType"
            :secondsData="read_sentence_seconds"
          />

          <Answer_question
            v-if="typeArr[selectedTypeIdx] === '回答問題'"
            :level="level"
            :questionData="examData"
            :unitTitle="unitTitle"
            :unit="typeArr[selectedTypeIdx]"
            @setIsStart="setIsStart"
            :isFirstGroup="calculateIsFirst(typeArr[selectedTypeIdx])"
            :isLastGroup="calculateIsLast(typeArr[selectedTypeIdx])"
            @guideNextType="guideNextType"
          />

          <DescribeImage
            v-if="
              typeArr[selectedTypeIdx] === '描述圖片' ||
              typeArr[selectedTypeIdx] === '看圖敘述'
            "
            :level="level"
            :questionData="examData"
            :unitTitle="unitTitle"
            :unit="typeArr[selectedTypeIdx]"
            @setIsStart="setIsStart"
            :isFirstGroup="calculateIsFirst(typeArr[selectedTypeIdx])"
            :isLastGroup="calculateIsLast(typeArr[selectedTypeIdx])"
            @guideNextType="guideNextType"
            :secondsData="describe_image_seconds"
          />

          <!-- writing -->
          <single_sentence_writing
            v-if="typeArr[selectedTypeIdx] === '單句寫作'"
            :questionData="examData"
            :level="level"
            :unit="typeArr[selectedTypeIdx]"
            :unitTitle="unitTitle"
            :currentName="typeArr[selectedTypeIdx]"
            :isFirstGroup="calculateIsFirst(typeArr[selectedTypeIdx])"
            :isLastGroup="calculateIsLast(typeArr[selectedTypeIdx])"
            @guideNextType="guideNextType"
          />

          <Essay
            v-if="
              typeArr[selectedTypeIdx] === '段落寫作' ||
              typeArr[selectedTypeIdx] === '中譯英' ||
              typeArr[selectedTypeIdx] === '英文作文'
            "
            :questionData="examData"
            :level="level"
            :unit="typeArr[selectedTypeIdx]"
            :unitTitle="unitTitle"
            :isFirstGroup="calculateIsFirst(typeArr[selectedTypeIdx])"
            :isLastGroup="calculateIsLast(typeArr[selectedTypeIdx])"
            :currentName="typeArr[selectedTypeIdx]"
            @guideNextType="guideNextType"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import api from '@/store/api'
import libraryApi from '@/store/library/api'
import SelectType from '@/views/AiHelper/GEPT/SelectType'
import Repeat from '@/views/AiHelper/GEPT/speaking/repeat'
import Read_sentences from '@/views/AiHelper/GEPT/speaking/read_sentences'
import Answer_question from '@/views/AiHelper/GEPT/speaking/answer_question'
import DescribeImage from '@/views/AiHelper/GEPT/speaking/describe_image'
import single_sentence_writing from '@/views/AiHelper/GEPT/writing/single_sentence_writing'
import Essay from '@/views/AiHelper/GEPT/writing/Essay'
import allJs from '@/components/AiHelper/all.js'
import geptI18n from '@/components/AiHelper/GEPT/i18n'

const GUIDE_PART_FIELDS = ['Description', 'Guide']
const GUIDE_QUESTION_FIELDS = ['Description', 'Guide', 'explain', 'Explain']
const GUIDE_PART_MATCH_FIELDS = ['Id', 'Name']
const GUIDE_QUESTION_MATCH_FIELDS = ['Id', 'id', 'QuestionId', 'question_id', 'questionId']

  export default {
    name: 'Practice',
    metaInfo () {
      return {
        title: this.$route.path.includes('quiz')
          ? this.$t('GEPT.common.quizWriting')
          : this.$t('GEPT.common.geptPractice')
      }
    },
    async beforeRouteLeave(to, from, next) {
      const isExemptRoute = to.name === 'gept_report_part' || to.name === 'gept_report_formal'
      if (!isExemptRoute && this.isStartExam) {
        if (await this.leavePageCheck()) {
          next()
        }
      } else {
        next()
      }
    },
    mixins: [
      allJs,
      geptI18n
    ],

    data () {
      return {
        selectedTypeIdx: 0,

        examData: null,
        level: null,
        unitTitle: null,
        guideDataCache: {
          examId: null,
          data: null
        },

        tags: null,

        isStartExam: false,

        formal_exam_record_id: null,

        intervalId: null
      }
    },

    components: {
      SelectType,

      Repeat,
      Read_sentences,
      Answer_question,
      DescribeImage,

      single_sentence_writing,
      Essay
    },

    watch: {
      '$route.params.select_id': {
        handler (newVal, oldVal) {
          if ((newVal !== oldVal)) {
            this.getContents()
            this.selectedTypeIdx = 0
          }
        }
      },
      '$route.params.practice_type': {
        handler (newVal, oldVal) {
          if ((newVal !== oldVal)) {
            this.selectedTypeIdx = 0
            this.getData(this.typeArr[this.selectedTypeIdx])
          }
        }
      }
    },

    computed: {
      ...mapGetters([
        'authorized',
        'remainPoints'
      ]),

      typeArr () {
        let self = this
        if (self.tags) {
          if (self.$route.params.practice_type === 'speaking') {
            return this.speakingArr
          } else {
            return this.writingArr
          }
        }
        if (this.$route.name === 'quiz_practice_speaking') {
          if (self.$route.params.practice_type === 'speaking') {
            return this.speakingArr
          } else {
            return this.writingArr
          }
        }
        return []
      },

      speakingArr () {
        let self = this
        if (self.tags) {
          let newArray = self.tags.filter((el) => {
            return el === '複誦' || el === '朗讀句子與短文' || el === '回答問題' || el === '描述圖片' || el === '朗讀短文' || el === '看圖敘述'
          })
          return newArray
        }
        return []
      },

      writingArr () {
        let self = this
        if (self.tags) {
          let newArray = self.tags.filter((el) => {
            return el === '段落寫作' || el === '單句寫作' || el === '中譯英' || el === '英文作文'
          })
          return newArray
        }
        if (this.$route.name === 'quiz_practice_speaking') {
          return ['中譯英', '英文作文']
        }
        return []
      },

      read_sentence_seconds () {
        if (this.level === '初級') {
          return { preRead: 60, exam: 60 }
        }
        return { preRead: 60, exam: 120 }
      },

      describe_image_seconds () {
        return { preRead: 30, exam: 90 }
      }
    },

    async mounted () {
      // this.$route.name === 'quiz_practice_speaking' ? this.getData() : this.startCheckingAuth()
      this.startCheckingAuth()
    },
    beforeDestroy () {
      if (this.intervalId) {
        clearInterval(this.intervalId)
      }
    },
    methods: {
      startCheckingAuth() {
        this.intervalId = setInterval(() => {
          this.$store.dispatch('isLoading', true)
          if (this.authorized) {
            clearInterval(this.intervalId)

            this.getContents()
            this.$route.query.pu || this.$route.query.p ? this.setPointsByRD() : null
            if (this.$route.query.record_id) {
              this.formal_exam_record_id = Number(this.$route.query.record_id)
            }
          }
        }, 1000)
      },
      getContents () {
        let self = this
        if (this.$route.name === 'quiz_practice_speaking') {
          this.tags = ['中譯英', '英文作文']
          this.$store.dispatch('isLoading', false)
          this.getData(this.typeArr[this.selectedTypeIdx])
          return
        }
        let path = `/assessments/exams/${this.$route.params.select_id}/contents`
        this.$store.dispatch('isLoading', true)
        api.get(path)
        .then(async(res) => {
          self.tags = res.data
          self.$store.dispatch('isLoading', false)

          if (self.$route.query.q) {
            await self.checkType()
            self.getData(self.typeArr[self.selectedTypeIdx])
          } else {
            self.getData(self.typeArr[self.selectedTypeIdx])
          }
        })
        .catch((err) => {
          self.$store.dispatch('isLoading', false)
        })
      },

      checkType () {
        let idx = this.typeArr.indexOf(this.$route.query.q)
        idx > -1 ? this.selectedTypeIdx = idx : null
      },

      shouldFetchGuideData (type) {
        return this.$route.params.practice_type === 'writing' ||
          this.$route.name === 'quiz_practice_speaking' ||
          this.writingArr.indexOf(type) > -1
      },

      async getGuideData (type) {
        if (!this.shouldFetchGuideData(type)) {
          return null
        }

        let examId = this.$route.params.select_id
        if (this.guideDataCache.examId === examId) {
          return this.guideDataCache.data
        }

        try {
          let res = await libraryApi.get(`/v1/livelibrary/Exam/${examId}/guide`)
          let guideData = res.data && res.data.status === 'OK' ? res.data.data : null
          this.guideDataCache = {
            examId,
            data: guideData
          }
          return guideData
        } catch (error) {
          return null
        }
      },

      mergeGuideData (examData, guideData) {
        let guideParts = this.getGuideParts(guideData)
        if (!guideParts.length) return examData

        let mergeParts = (parts) => {
          return parts.map((part, index) => {
            return this.mergeGuidePart(part, this.findGuideMatch(part, guideParts, index, GUIDE_PART_MATCH_FIELDS))
          })
        }

        if (Array.isArray(examData)) {
          return mergeParts(examData)
        }

        if (examData && Array.isArray(examData.Parts)) {
          return Object.assign({}, examData, {
            Parts: mergeParts(examData.Parts)
          })
        }

        return examData
      },

      getGuideParts (guideData) {
        return guideData && Array.isArray(guideData.Parts) ? guideData.Parts : []
      },

      mergeGuidePart (part, guidePart) {
        if (!part || !guidePart) return part

        let mergedPart = this.copyGuideFields(Object.assign({}, part), guidePart, GUIDE_PART_FIELDS)

        if (Array.isArray(part.Questions) && Array.isArray(guidePart.Questions)) {
          mergedPart.Questions = part.Questions.map((question, index) => {
            return this.mergeGuideQuestion(
              question,
              this.findGuideMatch(question, guidePart.Questions, index, GUIDE_QUESTION_MATCH_FIELDS)
            )
          })
        }

        return mergedPart
      },

      mergeGuideQuestion (question, guideQuestion) {
        if (!question || !guideQuestion) return question

        return this.copyGuideFields(Object.assign({}, question), guideQuestion, GUIDE_QUESTION_FIELDS)
      },

      copyGuideFields (target, source, fields) {
        fields.forEach((field) => {
          if (Object.prototype.hasOwnProperty.call(source, field)) {
            target[field] = source[field]
          }
        })
        return target
      },

      findGuideMatch (item, guideItems, index, matchFields) {
        if (!item) return guideItems[index]

        for (let field of matchFields) {
          let value = item[field]
          if (value) {
            let matchedItem = guideItems.find((guideItem) => guideItem && guideItem[field] === value)
            if (matchedItem) return matchedItem
          }
        }

        return guideItems[index]
      },

      getTypeText (type) {
        return type || 'speaking'
      },

      getRawExamData (data) {
        if (this.$route.name === 'quiz_practice_speaking') {
          let parts = this.getQuizExamParts(data)
          let selectedType = this.typeArr[this.selectedTypeIdx]
          let normalizedSelectedType = this.normalizePartName(selectedType)
          let matchedParts = parts.filter(item => {
            return [
              item && item.Name,
              item && item.name,
              item && item.Title,
              item && item.title
            ].some(name => this.normalizePartName(name) === normalizedSelectedType)
          })

          if (matchedParts.length > 0) return matchedParts

          let fallbackPart = parts[this.selectedTypeIdx]
          return fallbackPart ? [fallbackPart] : parts
        }

        return this.$route.params.practice_type === 'speaking' ? data.data[0] : data.data
      },

      getQuizExamParts (data) {
        let payload = data && data.data

        if (Array.isArray(payload)) return payload
        if (payload && Array.isArray(payload.Parts)) return payload.Parts
        if (data && Array.isArray(data.Parts)) return data.Parts

        return []
      },

      normalizePartName (name) {
        return String(name || '').replace(/\s+/g, '').trim()
      },

      applyExamData (data, guideData) {
        this.examData = this.mergeGuideData(this.getRawExamData(data), guideData)
        this.level = data.level
        this.unitTitle = data.name

        if (this.$route.name === 'quiz_practice_speaking') return

        this.$store.dispatch('setLevel', data.level)
        this.handleQueryRedirect()
      },

      handleQueryRedirect () {
        if (!this.$route.query.q) return

        let route = {
          name: 'practice_speaking',
          params: { select_id: this.$route.params.select_id, practice_type: this.$route.params.practice_type }
        }
        if (this.$route.query.sid) {
          route.query = { sid: this.$route.query.sid }
        }
        this.$nextTick(() => {
          this.$router.push(route)
        })
      },

      async getData (type) {
        let path = `/assessments/exams/${this.$route.params.select_id}?type=${this.getTypeText(type)}`
        this.$store.dispatch('isLoading', true)
        this.examData = null

        try {
          let [res, guideData] = await Promise.all([
            api.get(path),
            this.getGuideData(type)
          ])
          this.applyExamData(res.data, guideData)
        } catch (error) {
          this.examData = null
        } finally {
          this.$store.dispatch('isLoading', false)
        }
      },

      async selectQuestion (idx) {
        if (this.selectedTypeIdx === idx) return

        if (this.isStartExam) {
          const canLeave = await this.leavePageCheck()
          if (!canLeave) return
        }

        this.selectedTypeIdx = idx

        // if (this.$route.name === 'quiz_practice_speaking') {

        // } else {
        //   this.getData(this.typeArr[idx])
        // }
        this.getData(this.typeArr[idx])
      },

      leavePageCheck () {
        let self = this
        return self.$swal.fire({
          title: this.$t('GEPT.alerts.leaveTitle'),
          text: this.$t('GEPT.alerts.leaveText'),
          showCloseButton: true,
          focusConfirm: false,
          showDenyButton: true,
          confirmButtonText: this.$t('GEPT.alerts.continueAnswering'),
          denyButtonText: this.$t('GEPT.alerts.confirmLeave'),
          customClass: {
            popup: 'gept-leave-popup',
            title: 'gept-leave-title',
            closeButton: '',
            htmlContainer: 'gept-leave-content',
            actions: 'gept-leave-actions',
            confirmButton: 'submitButton-gept gept-leave-confirm',
            denyButton: 'denyButton-gept gept-leave-deny',
          }
        })
        .then((result) => {
            if (result.isDenied === true) {
              return true
            }
            return false
          }
        )
      },

      setIsStart (setIsStart) {
        this.isStartExam = setIsStart
      },

      guideNextType () {
        let self = this
        if (self.selectedTypeIdx < self.typeArr.length - 1) {
          self.selectedTypeIdx++
          self.getData(self.typeArr[self.selectedTypeIdx])
        }
      },

      calculateIsFirst (element) {
        // 判斷是否為第一個
        let self = this

        if (Array.isArray(self.typeArr) && self.typeArr.length > 0) {

          return self.typeArr[0] === element
        }
        return false
      },

      calculateIsLast (element) {
        // 判斷是否為最後一回
        let self = this

        if (Array.isArray(self.typeArr) && self.typeArr.length > 0) {

          return self.typeArr[self.typeArr.length - 1] === element
        }
        return false
      },

      setPointsByRD () {
        localStorage.setItem('RD_pu', this.$route.query.pu)
        localStorage.setItem('RD_p', this.$route.query.p)
      }
    }
  }
</script>
<style lang="scss" scoped>
.practice {
  ul {
    list-style-type: none;
  }
  .active {
    color: white;
    background-color: #145F7F;
  }
  .content_inner {
    min-height: calc(70vh);
  }
}
</style>
